import { z } from "zod";

export const FileId = z.string();

export const FileRef = z.object({
    id: FileId,
    extension: z.string(),
    name: z.string(),
    url: z.string(),
    sizeBytes: z.number(),
});
